import React, { useState } from 'react';
import { CssBaseline, Toolbar } from '@mui/material';
import Gene20Box from '../../Components/Gene20Box/Gene20Box';
import { useDispatch, useSelector } from 'react-redux';

import { Gene20CoverContainer } from '../../layouts/layoutContainers';
import PageRoutes from '../../routes/pageRoutes';
import PageRoutesData from '../../routes/data/pageRoutesData';
import Gene20SideNavRoot from '../Gene20Drawer/Gene20SideNavRoot';
import DashBoardAppBar from './components/DashBoardAppBar';
import DashBoardMenu from './components/dashBoardMenu';
import { toogleMenu } from '../../redux/reducers/menuSlice';

export default function Gene20Dashboard(props, ...rest) {
  const { window, drawerWidth } = props;
  let textColor = 'white';
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mystate, setMystate] = useState(PageRoutesData);

  const handleClick = (v) => {
    setMystate(() => {
      let myNewState = mystate.map((ll) => {
        if (v.title === ll.title) {
          let mynewObject = { ...ll, value: !ll.value };
          return mynewObject;
        } else {
          return ll;
        }
      });
      return myNewState;
    });
  };

  const container = window !== undefined ? () => window().document.body : undefined;
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.menu.isOpen);

  return (
    <Gene20Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <DashBoardAppBar />
      <Gene20Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Gene20SideNavRoot
          {...rest}
          container={container}
          variant="temporary"
          open={isOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'flex', sm: 'none' },

            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
        >
          <DashBoardMenu />
        </Gene20SideNavRoot>
        <Gene20SideNavRoot
          {...rest}
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
          open
        >
          <DashBoardMenu />
        </Gene20SideNavRoot>
      </Gene20Box>
      <Gene20Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />
        <Gene20CoverContainer>
          <PageRoutes />
        </Gene20CoverContainer>
      </Gene20Box>
    </Gene20Box>
  );
}
